<div class="containerList">
  <ng-container *ngFor="let order of orders">
    <app-order-list-item [order]="order"></app-order-list-item>
  </ng-container>
</div>

<div *ngIf="mostrarPaginado" class="orders-paginado">

  <button mat-stroked-button
          *ngIf="hayPaginaAnterior"
          (click)="verAnterior()">
    <mat-icon>chevron_left</mat-icon> Anteriores
  </button>

  <span class="orders-paginado-texto">
    Página {{ pageIndex + 1 }} de {{ totalPages }}
  </span>

  <button mat-stroked-button
          *ngIf="hayPaginaSiguiente"
          (click)="verMas()">
    Ver más <mat-icon>chevron_right</mat-icon>
  </button>

</div>

<div *ngIf="!isLoading && orders?.length == 0" class="alert-info" style="margin: 16px;">
  <mat-icon>search_off</mat-icon> <span> No hay órdenes para mostrar  </span>
</div>

<loading-indicator *ngIf="isLoading"></loading-indicator>
